import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;

    width: 100%;
    max-width: 72rem;
    margin-left: auto;
    margin-right: auto;

    // background-color: #d3d3d3;
    background-color: white;
`;

export const ListItemContainer = styled.div`

`;

export const Header = styled.div`

    display: flex;
    flex-direction: row;
    justify-content: space-between;

    align-items: center;

    padding: 10px 20px 10px 20px;

`;

export const TituloContainer = styled.div`

    > h1 {
        font-family: 'Roboto', sans-serif;
        font-size: bold;
    }

`;

export const BotoesContainer = styled.div`

    display: flex;
    flex-direction: column;
    justify-content: space-evenly;

    gap: 10px;

`;

export const Botao = styled.button`

    display: flex;
    flex-direction: row;

    gap: 10px;

    align-items: center;
    text-align: center;
    border-radius: 10px;

    transition: opacity .3s;
    &:hover {
        opacity: .7;
        background-color: #F0E68C;
    }

`;

export const FiltersContainer = styled.div``;

export const FiltersContent = styled.div`
    display: flex;
    flex-direction: row;

    justify-content: left;

    gap: 10px;
`;

export const FilterBox = styled.div`
    /* background-color: ; */
    padding: 7px;
    margin-top: 10px;
    border-radius: 10px;
    /* border: 1px gray solid; */

    transition: opacity .3s;
    &:hover {
        opacity: .7;
        background-color: #d1d1d1;
    }
`;